import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import InfoModal from './InfoModal'
import { PscPhrase } from '../psc-phrase';

import useUserManagement from '../../../hooks/useUserManagement'
import useProjectContents from '../../../hooks/useProjectContents'
import useGncHistory from '../../../hooks/useGncHistory'

const ManualUpversion = (props) => {
    const id = props.id
    const projectId = props.project_id
    const originalStatus = props.originalStatus
    const status = props.status
    const characteristics = props.characteristics
    const referenceWithoutVersion = props.referenceWithoutVersion
    const version = props.version
    const user = props.user

    const navigate = useNavigate()
    const latestNotWithdrawnVersion = characteristics.has_later_not_withdrawn ? false: true

    const [showNoVersionModal, setShowNoVersionModal] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [origVersion, setOrigVersion] = useState(version)
    const [newVersion, setNewVersion] = useState("")
    const [submit, setSubmit] = useState(false)
    const [error, setError] = useState("")

    const {
        userHasProjectAccessLevel,
    } = useUserManagement()
    
    const {
        forceReloadCustomerDocuments,
    } = useProjectContents()
    
    const {
        replaceCurrentPath,
    } = useGncHistory()
    
    // Might not be relevant with an Upversion button
    if( ! id ) return null
    if( ! userHasProjectAccessLevel(user, projectId, "MEMBER") ) return null
    if( ! latestNotWithdrawnVersion ) return null
    if( originalStatus !== "Filed" ) return null
    if( status !== "Filed" ) return null
    
    // So without a version, we require the user to be CADM Controller. Because to proceed they will change the Version value of the
    // Filed version of the Document
    if( version === "" && ! userHasProjectAccessLevel(user, projectId, "CADM_CONTROLLER") ) {
        const modalContent = (
            <div>
                <div>Upversion allows you to supersede this Customer Document with a new version.</div>
                <div>&nbsp;</div>
                <div>To enable upversion, <i>this</i> Customer Document needs a version.</div>
                <div>This can be added by: CADM Controller.</div>
            </div>
        )
        return (
            <>
            <InfoModal
                title="Upversion"
                titleIcon="fa fa-info-circle"
                bodyContent={modalContent}
                show={showNoVersionModal}
                onClose={() => setShowNoVersionModal(false)}
            />
            <button key="upversion-button" className="btn" type="button" onClick={() => setShowNoVersionModal(true)}>
                <i className="fa fa-info-circle"></i> Upversion
            </button>
            </>
        )
    }


    const onSubmit = (event) => {
        if( event ) {
            event.preventDefault();
        }
        if( submit ) {
            return
        }

        setError(null)
        let error = []
        if ( version === "" && ( ! origVersion || /^\s+$/.test(origVersion) ) ) {
            error.push("Current Version is required")
        }
        
        if ( ! newVersion || /^\s+$/.test(newVersion) ) {
            error.push("New Version is required")
        }
        if ( error.length > 0 ) {
            setError(error)
            return
        }

        setSubmit(true)

        const url = '/v0/customer_documents/'+id+'/upversion';
        let data = { id: id, original_version: origVersion, new_version: newVersion }
        
        fetch(url, {
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) throw response
                return response.json()
            })
            .then(json => {
                setShowModal(false)
                setSubmit(false)
                forceReloadCustomerDocuments()
                replaceCurrentPath('/portfolio/'+projectId+'/customer_documents')
                navigate('/portfolio/'+projectId+'/customer_documents/'+json.result.id)
            })
            .catch(error => {
                console.log("ManualUpversion error:", error)
                setShowModal(true)
                setSubmit(false)
                setError("The given Version already exists")
            })
    }

    const origVersionBlock = () => {
        if( version === "" ) {
            return (
                <div className="form-group">
                    <label className="col-sm-2 control-label">
                        Current Version
                        <label className="form-required-star">&nbsp;*</label>
                    </label>
                    
                    <div className="col-sm-8">
                        <input className="form-control" type="text"
                               name="orig_version"
                               value={origVersion}
                               onChange={e => setOrigVersion(e.target.value)}
                               maxLength="10"
                               autoComplete="off"
                               required
                        />
                    </div>
                </div>
            )
        }
        return (
            <div className="form-group">
                <label className="col-sm-2 control-label">
                    Current Version
                </label>
                
                <div className="col-sm-8">
                    <input className="form-control" type="text"
                           name="version"
                           value={version}
                           disabled
                    />
                </div>
            </div>
        )
    }

    return (
        <>
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
            <form className="form-horizontal">
            <Modal.Header closeButton>
                <Modal.Title className="text-center full-width">
                    <i  style={{fontSize: '84px', color: '#e2e3e3'}} className="fa fa-bank" />
                    <h4 style={{fontSize: '28px'}}>Upversion this Customer Document</h4>
                    <h4 style={{fontSize: '18px'}}>From current version to a new version</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    <label className="col-sm-2 control-label">
                        {PscPhrase("LABEL_REFERENCE")}
                    </label>

                    <div className="col-sm-8">
                        <input className="form-control" type="text"
                                name="reference_without_version"
                                value={referenceWithoutVersion}
                                disabled
                        />
                    </div>
                </div>

                {origVersionBlock()}
                    
                <div className="form-group">
                    <label className="col-sm-2 control-label">
                        New Version
                        <label className="form-required-star">&nbsp;*</label>
                    </label>

                    <div className="col-sm-8">
                        <input className="form-control" type="text"
                                value={newVersion}
                                onChange={e => setNewVersion(e.target.value)}
                                maxLength="10"
                                autoComplete="off"
                                required
                        />
                        <span className="help-block m-b-none m-t-none">
                            <small className="form-info-text" > A new customer document will be reserved with this version. </small>
                        </span>
                    </div>
                </div>
                    
                {error &&
                    <div className="form-group">
                        <div className="error-message alert alert-danger">{error}</div>
                    </div>
                }
            </Modal.Body>
            <Modal.Footer>

                <Button variant="light" onClick={() => setShowModal(false)}>
                    Close
                </Button>

                <Button variant="primary" onClick={onSubmit}>
                    OK
                </Button>

            </Modal.Footer>
            </form>
        </Modal>

        <button key="upversion-button" className="btn btn-mr btn-warning"
                type="button" onClick={() => setShowModal(true)}
        >
            Upversion
        </button>
        </>
    )
}

export default ManualUpversion
